/* The "shop by theme" strip: a draggable scrollbar under the tiles.

   The row is a native scroller, so it already works by swipe, trackpad, wheel
   and keyboard. What a desktop mouse does not get from a native scroller is
   anything to grab - the browser's own bar is hidden in CSS because it looks
   wrong under artwork. This draws one that matches the row and lets you drag
   it, at every screen size.

   Everything is built here rather than in Liquid so that without JavaScript
   the row is still a plain, usable scroller with no dead controls on top. */
(function () {
  'use strict';

  function attach(wrap) {
    if (wrap.dataset.wpThemesReady) return;
    var strip = wrap.querySelector('.wp-themes');
    var bar = wrap.querySelector('.wp-themes__bar');
    var thumb = wrap.querySelector('.wp-themes__thumb');
    if (!strip || !bar || !thumb) return;
    wrap.dataset.wpThemesReady = '1';

    var dragging = false;

    function maxScroll() {
      return strip.scrollWidth - strip.clientWidth;
    }

    function update() {
      var max = maxScroll();
      if (max <= 1) {
        wrap.classList.add('wp-themes-wrap--fits');
        return;
      }
      wrap.classList.remove('wp-themes-wrap--fits');

      var visible = strip.clientWidth / strip.scrollWidth;
      thumb.style.width = visible * 100 + '%';
      // The thumb travels the track's width less its own, which expressed as a
      // percentage of the thumb itself is (100 / visible) - 100.
      thumb.style.transform =
        'translateX(' + (strip.scrollLeft / max) * (100 / visible - 100) + '%)';
    }

    /* Map a pointer position on the track to a scroll position. The thumb is
       centred on the pointer, so the grab point does not jump, and the usable
       track is shortened by the thumb's own width at both ends. */
    function scrollToPointer(clientX) {
      var rect = bar.getBoundingClientRect();
      var thumbW = thumb.getBoundingClientRect().width;
      var travel = rect.width - thumbW;
      if (travel <= 0) return;
      var x = clientX - rect.left - thumbW / 2;
      var ratio = Math.min(Math.max(x / travel, 0), 1);
      strip.scrollLeft = ratio * maxScroll();
    }

    bar.addEventListener('pointerdown', function (e) {
      if (wrap.classList.contains('wp-themes-wrap--fits')) return;
      dragging = true;
      bar.setPointerCapture(e.pointerId);
      wrap.classList.add('wp-themes-wrap--dragging');
      // A press anywhere on the track jumps there, the way a scrollbar does.
      scrollToPointer(e.clientX);
      e.preventDefault();
    });

    bar.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      scrollToPointer(e.clientX);
      e.preventDefault();
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      wrap.classList.remove('wp-themes-wrap--dragging');
      if (e && e.pointerId != null && bar.hasPointerCapture(e.pointerId)) {
        bar.releasePointerCapture(e.pointerId);
      }
    }

    bar.addEventListener('pointerup', endDrag);
    // A cancelled pointer (the browser taking over for a gesture, the tab
    // hiding) never fires pointerup, and without this the bar stays stuck to
    // the cursor afterwards.
    bar.addEventListener('pointercancel', endDrag);

    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // Images arrive after first paint and change scrollWidth, so measure again.
    window.addEventListener('load', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-wp-themes]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor rebuilds a section's markup in place.
  document.addEventListener('shopify:section:load', init);
})();
